import { render, staticRenderFns } from "./GoogleCalendarEventEditCard.vue?vue&type=template&id=740c943c"
import script from "./GoogleCalendarEventEditCard.vue?vue&type=script&lang=ts"
export * from "./GoogleCalendarEventEditCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('740c943c')) {
      api.createRecord('740c943c', component.options)
    } else {
      api.reload('740c943c', component.options)
    }
    module.hot.accept("./GoogleCalendarEventEditCard.vue?vue&type=template&id=740c943c", function () {
      api.rerender('740c943c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/GoogleCalendarEventEditCard.vue"
export default component.exports